export const RISK_OPTION = 0;
export const COMPLIANCE_OPTION = 1;
export const CONFORMITY_OPTION = 2;
